export default {
  en: {
    'components.multi-country-selector.title': 'Jurisdiction',
    'components.multi-country-selector.drop-down.title': 'Jurisdictions',
  },
};
